<!--
 * @Author: your name
 * @Date: 2020-08-13 20:52:36
 * @LastEditTime: 2022-06-08 16:34:10
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/order-history/index.vue
-->
<style lang="sass" scoped>
.enter_phone_number
  display: flex
  justify-content: center
  margin-top: 32px
  font-size: 12px
  color: rgba(51, 68, 85, .75)

  .body_box
    display: flex
    flex-direction: column
    align-items: center
    width: 284px

    .icon_container
      .icon
        height: 67px

    .title
      margin-top: 18px
      font-size: 16px
      font-weight: bold
      color: #334455

    .text
      margin-top: 14px
      text-align: center

    .form
      .phone
        display: flex
        align-items: center
        justify-content: space-between
        margin-top: 14px

        .select
          align-self: flex-end
          margin-right: 25px
          margin-bottom: 20px

        .phone_num
          flex: 1

.button
  margin-top: 20px
  height: auto
  border: none
  padding: 0 80PX
  border-radius: 5PX !important
  font-size: 14PX
  height: 54PX

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)
</style>

<template lang="pug">
  .enter_phone_number
    .body_box
      .icon_container
        img.icon(:src="lockSrc")
      .title {{ t('enter_your_phone_number', 'Enter your phone number') }}
      .text {{ t('retrieve_order_history_text', 'To retrieve your order history, please enter the phone number you provided when placing your orders.') }}
      py-form.form(
        ref="form"
        id="scroll_bar"
        :model="userInfo"
        :rules="ruleValidate"
      )
        .phone.ns
          CountrySelect.select(
            v-model="country"
            :countriesList="countriesList"
            disabled
          )
          py-form-item.phone_num(prop='phoneNumber')
            py-input(
              v-model="userInfo.phoneNumber"
              title='Phone Number'
              type="number"
              @input="val => userInfo.phoneNumber = userInfo.phoneNumber.trim()"
          )
      van-button.button.b(type="primary" @click="submit") {{ t('submit', 'SUBMIT') }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import CountrySelect from 'components/CountrySelect'
import { mapState } from 'vuex'
import countriesList from '@/plugins/countries'
import { restoreUser } from '@/api/product'
import resizeHandler from 'utils/resizeHandler'
import { t } from '@/utils/language'

const phoneNumberRule = (rule, value, callback) => {
  value = value.trim()
  const reg = /^\d{1,}$/
  if (isNaN(value)) {
    callback(new Error(t('phone_format_incorrect', 'PhoneNumber format is incorrect')))
  }
  if (!reg.test(value)) {
    callback(new Error(t('please_enter_phone', 'Please enter your phone number')))
  }
  if (value.length < 6) {
    callback(new Error(t('phone_min_length', 'PhoneNumber is greater than 6')))
  }
  if (value.length > 14) {
    callback(new Error(t('phone_max_length', 'PhoneNumber is greater less than 14')))
  }
  callback()
}

@Component({
  mixins: [resizeHandler],

  components: {
    CountrySelect,
  },

  computed: {
    ...mapState({
      venueCountry: state => state.venueHome.venueCountry,
    }),
    ...mapState(['venueId'])
  }
})

class EnterPhoneNumber extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  lockSrc = require('@/assets/phone.png')
  countriesList = countriesList
  country = {}
  userInfo = {}
  ruleValidate = {
    phoneNumber: [
      { validator: phoneNumberRule, trigger: 'blur' }
    ],
  }

  created() {
    this.country = this._getCountry()[0]
  }

  submit() {
    this.$refs.form.validate(async (valid) => {
      if (valid) {
        try {
          const phoneNumber = this.userInfo.phoneNumber
          this.$store.commit('showLoading')
          await restoreUser({
            action: 'sendVerificationCode',
            phone: phoneNumber,
            countryCode: this.country.code.toLowerCase()
          })
          this.$store.commit('closeLoading')
          this.$router.push(`/v/${this.venueId}/login/verification-code?phoneNumber=${encodeURIComponent(phoneNumber)}&userCode=${this.country.dial_code}&countryCode=${this.country.code.toLowerCase()}`)
        } catch (error) {
          this.$store.commit('closeLoading')
        }
      }
    })
  }

  _getCountry() {
    return this.countriesList.filter(item => {
      if (item.code.toLowerCase() === this.venueCountry.toLowerCase()) {
        return item
      }
    })
  }
}

export default EnterPhoneNumber
</script>
